// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  width: 50%;
  padding-left: 35px;
}
.chat-container a {
  color: #163B6B;
}
.chat-container .custom-card {
  padding: 40px 24px;
  border-radius: 24px;
}
.chat-container .social-links {
  margin-top: 16px;
  margin-bottom: 24px;
}
.chat-container .social-links ul {
  display: flex;
  justify-content: space-evenly;
}
.chat-container .social-links ul li {
  text-align: center;
  cursor: pointer;
}
.chat-container .social-links ul li .icon {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}
.chat-container .social-links ul li .icon.whatsapp img {
  width: 140%;
  max-width: none;
}
.chat-container .social-links ul li .name {
  margin-top: 8px;
}
.chat-container .social-links .message {
  font-size: 16px;
  text-align: center;
  padding-top: 16px;
  font-weight: 600;
  max-width: 280px;
  margin: 0 auto;
}
.chat-container .write-email {
  margin-top: 8px;
}
.chat-container .write-email ul {
  display: flex;
  justify-content: center;
}
.chat-container .write-email ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.chat-container .write-email ul li .icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .chat-container {
    padding-left: 16px;
  }
  .chat-container .social-links {
    margin-bottom: 16px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .chat-container {
    width: 100%;
    padding-left: 0;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .chat-container .custom-card {
    border-radius: 16px;
  }
  .chat-container .social-links {
    margin-bottom: 24px;
  }
  .chat-container .social-links ul {
    flex-wrap: wrap;
    width: 155px;
    margin: 0 auto;
  }
  .chat-container .social-links ul li {
    width: 100%;
    padding-top: 24px;
    text-align: left;
  }
  .chat-container .social-links ul li:first-child {
    padding-top: 0;
  }
  .chat-container .social-links ul li a {
    display: flex;
    align-items: center;
  }
  .chat-container .social-links ul li .icon {
    margin: 0;
    width: 60px;
    height: auto;
  }
  .chat-container .social-links ul li .icon.whatsapp img {
    width: 100%;
    margin-left: -9px;
  }
  .chat-container .social-links ul li .name {
    font-size: 14px;
    padding-left: 16px;
    margin: 0;
    width: calc(100% - 60px);
  }
  .chat-container .write-email ul li {
    width: 100%;
    flex-direction: column;
    text-align: center;
  }
  .chat-container .write-email ul li .icon {
    width: auto;
    margin: 0;
  }
  .chat-container .write-email ul li .name {
    font-size: 14px;
    padding-left: 0;
    margin: 0;
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ChatWithUs/ChatWithUs.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,kBAAA;AACF;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,kBAAA;EACA,mBAAA;AAEJ;AAAE;EACE,gBAAA;EACA,mBAAA;AAEJ;AADI;EACE,aAAA;EACA,6BAAA;AAGN;AAFM;EACE,kBAAA;EACA,eAAA;AAIR;AAHQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAKV;AAHY;EACE,WAAA;EACA,eAAA;AAKd;AADQ;EACE,eAAA;AAGV;AACI;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACN;AAEE;EACE,eAAA;AAAJ;AACI;EACE,aAAA;EACA,uBAAA;AACN;AAAM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAER;AADQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAGV;;AAIA;EACE;IACE,kBAAA;EADF;EAEE;IACI,mBAAA;EAAN;AACF;AAGA;EACE;IACE,WAAA;IACA,eAAA;EADF;AACF;AAGA;EAEI;IACI,mBAAA;EAFN;EAIE;IACI,mBAAA;EAFN;EAGM;IACI,eAAA;IACA,YAAA;IACA,cAAA;EADV;EAEU;IACI,WAAA;IACA,iBAAA;IACA,gBAAA;EAAd;EACc;IACI,cAAA;EAClB;EACc;IACI,aAAA;IACA,mBAAA;EAClB;EACc;IACI,SAAA;IACA,WAAA;IACA,YAAA;EAClB;EACoB;IACE,WAAA;IACA,iBAAA;EACtB;EAGc;IACI,eAAA;IACA,kBAAA;IACA,SAAA;IACA,wBAAA;EADlB;EAQU;IACI,WAAA;IACA,sBAAA;IACA,kBAAA;EANd;EAOc;IACI,WAAA;IACA,SAAA;EALlB;EAOc;IACI,eAAA;IACA,eAAA;IACA,SAAA;IACA,iBAAA;EALlB;AACF","sourcesContent":[".chat-container{\r\n  width: 50%;\r\n  padding-left: 35px;  \r\n  a{\r\n    color: #163B6B;\r\n  }\r\n  .custom-card{\r\n    padding:40px 24px;\r\n    border-radius: 24px; \r\n  }\r\n  .social-links{\r\n    margin-top: 16px;\r\n    margin-bottom: 24px;    \r\n    ul{\r\n      display: flex;\r\n      justify-content: space-evenly;\r\n      li{\r\n        text-align: center;\r\n        cursor: pointer;\r\n        .icon{\r\n          width: 40px;\r\n          height: 40px;\r\n          margin: 0 auto;\r\n          &.whatsapp{\r\n            img{\r\n              width: 140%;\r\n              max-width: none;\r\n            }\r\n          }\r\n        }\r\n        .name{\r\n          margin-top: 8px;\r\n        }\r\n      }\r\n    }\r\n    .message{\r\n      font-size: 16px;\r\n      text-align: center;\r\n      padding-top: 16px;\r\n      font-weight: 600;\r\n      max-width: 280px;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n  .write-email{\r\n    margin-top: 8px;\r\n    ul{\r\n      display: flex;\r\n      justify-content: center;\r\n      li{\r\n        display: flex;\r\n        align-items: center;     \r\n        justify-content: center;\r\n        flex-direction: column;   \r\n        .icon{\r\n          width: 40px;\r\n          height: 40px;\r\n          display: flex;\r\n          align-items: center;    \r\n          margin-bottom: 8px;      \r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .chat-container{\r\n    padding-left: 16px;\r\n    .social-links{\r\n        margin-bottom: 16px;\r\n    }\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .chat-container{\r\n    width: 100%;\r\n    padding-left: 0;\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .chat-container{\r\n    .custom-card{\r\n        border-radius: 16px;\r\n    }\r\n    .social-links{\r\n        margin-bottom: 24px;\r\n        ul{\r\n            flex-wrap: wrap;\r\n            width: 155px;\r\n            margin: 0 auto;\r\n            li{\r\n                width: 100%;\r\n                padding-top: 24px;\r\n                text-align: left;\r\n                &:first-child{\r\n                    padding-top: 0;\r\n                }\r\n                a{\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n                .icon{\r\n                    margin: 0;\r\n                    width: 60px;\r\n                    height: auto;\r\n                    &.whatsapp{\r\n                      img{\r\n                        width: 100%;\r\n                        margin-left: -9px;\r\n                      }\r\n                    }\r\n                }\r\n                .name{\r\n                    font-size: 14px;\r\n                    padding-left: 16px;\r\n                    margin: 0;\r\n                    width: calc(100% - 60px);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .write-email {\r\n        ul {\r\n            li{\r\n                width: 100%;\r\n                flex-direction: column;\r\n                text-align: center;\r\n                .icon{\r\n                    width: auto;\r\n                    margin: 0;\r\n                }\r\n                .name{\r\n                    font-size: 14px;\r\n                    padding-left: 0;\r\n                    margin: 0;\r\n                    padding-top: 20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
